import { useState, KeyboardEvent } from 'react'
import { cn } from '@/lib/utils'

interface TagsInputProps {
  tags: string[]
  onChange: (tags: string[]) => void
  placeholder?: string
  className?: string
  /** id del campo de texto, para asociarlo a un `label`. */
  id?: string
  /** Tope de etiquetas; al alcanzarlo no se aceptan más. */
  maxItems?: number
}

export default function TagsInput({ tags, onChange, placeholder = 'Escribe y presiona Enter...', className, id, maxItems }: TagsInputProps) {
  const [inputValue, setInputValue] = useState('')

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault()
      if (!tags.includes(inputValue.trim()) && (maxItems === undefined || tags.length < maxItems)) {
        onChange([...tags, inputValue.trim()])
      }
      setInputValue('')
    } else if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
      onChange(tags.slice(0, -1))
    }
  }

  const removeTag = (index: number) => {
    onChange(tags.filter((_, i) => i !== index))
  }

  return (
    <div className={cn('flex flex-wrap gap-2 p-2 border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-[#075E54] focus-within:border-transparent', className)}>
      {tags.map((tag, index) => (
        <span
          key={tag}
          className="inline-flex items-center gap-1 px-2 py-1 bg-[#075E54]/10 text-[#075E54] rounded-md text-sm font-medium"
        >
          {tag}
          <button
            type="button"
            onClick={() => removeTag(index)}
            aria-label={`Quitar ${tag}`}
            className="hover:text-[#064E46] transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </span>
      ))}
      <input
        id={id}
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={tags.length === 0 ? placeholder : ''}
        className="flex-1 min-w-[120px] outline-none bg-transparent text-sm"
      />
    </div>
  )
}

